import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";
import { ItemProcessosInteresseFilter } from "../../models/item_processos_interesse_filter";
import { IGetAllItemProcessoInteresseUseCase } from "../../../presentation/useCases/read/get_all_qualidade_item_processo_interesse_use_case";
import { ItemProcessoRiscosInteresseLista } from "../../models/processos_riscos_item_interesse_lista";


// GetAllQualidadeProcessosInteresseServicoUseCase


export class GetAllQualidadeItemProcessosInteresseServicoUseCase
  extends BasePaginatedUseCase<ItemProcessoRiscosInteresseLista>
  implements IGetAllItemProcessoInteresseUseCase {
  constructor(private readonly repository: IQualidadeRepository) {
    super();
  }

  async getAllListagemItemProcessoInteresse(
    filter: ItemProcessosInteresseFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    
    const response = await this.repository
      .getAllListagemItemProcessoInteresse(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
